import { SkuCardData } from '@/types/cards';
import { SkuDTO } from '@/types/api/sku';

export default function getSkuCardDescription(
  sku: SkuDTO | null | SkuCardData,
  IncludeVolumeInPercent = true
) {
  const {
    bottleSizeInMl: skuBottleSizeInMl = 700,
    volumeInPercent: skuVolumeInPercent = 40,
    releaseDate: skuReleaseDate,
  } = sku || {};

  const bottleSizeInMl = (skuBottleSizeInMl ?? 700) / 10 || '';
  const volumeInPercent = (skuVolumeInPercent ?? 40) / 10 || '';

  const releaseDateNull = new Date().getFullYear();
  const releaseDateType = skuReleaseDate
    ? new Date(skuReleaseDate).getFullYear()
    : '';

  const releaseDate = releaseDateType !== 1970 ? releaseDateType : '';
  const releaseDateToUse = sku === null ? releaseDateNull : releaseDate;

  let description = '';

  if (bottleSizeInMl) {
    description += `${bottleSizeInMl}cl ${IncludeVolumeInPercent ? '|' : ''} `;
  }
  if (IncludeVolumeInPercent && volumeInPercent) {
    description += `${volumeInPercent}% `;
  }
  if (releaseDateToUse) {
    description += `| ${releaseDateToUse}`;
  }

  return description.trim();
}
